export default "__VITE_ASSET__Ch4CXOc9__"